import(/* webpackMode: "eager" */ "/vercel/path0/app/event-request/page.tsx");
